// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2j9tZ","col":"CardReaderDesc_col__3z_IT","label":"CardReaderDesc_label__2rk-s"};